// 「新機能の紹介」の中身 (web に同梱)。新しい紹介は **この配列に足すだけ**。
// id は一度出したら変えない (既読管理のキー)。動画 / 静止画は src/assets/whats-new/ に置く
// (Vite がハッシュ付き asset にする)。

import { OEKAKI_TOP_URL } from '../application/timelapseShare.js';
import layerThumbnailVideo from '../assets/whats-new/layer-thumbnail.mp4';
import layerThumbnailPoster from '../assets/whats-new/layer-thumbnail-poster.jpg';
import regionMoveVideo from '../assets/whats-new/region-move.mp4';
import regionMovePoster from '../assets/whats-new/region-move-poster.jpg';
import type { WhatsNewEntry } from '../domain/whatsNew.js';

/** 枠ができる前の更新は www の更新履歴に任せる (アプリ内の紹介は今後増えていく前提)。 */
export const WHATS_NEW_ARCHIVE_URL = `${OEKAKI_TOP_URL}/updates/`;

export const WHATS_NEW_ENTRIES: ReadonlyArray<WhatsNewEntry> = [
  {
    id: '2026-10-region-move',
    date: '2026年10月',
    sortKey: '2026-10',
    title: '選んだ範囲を移動・コピーできるようになりました',
    body: '「範囲」の道具で四角く囲むと、その中の絵を動かしたり、複製したりできます。どのレイヤーを動かすか、どのレイヤーに置くかも選べます。置いたあとでも「元に戻す」で取り消せます。「範囲」の道具は、Modern では左の列、Classic では「道具」の中、スマホではブラシ設定の中にあります。',
    videoUrl: regionMoveVideo,
    posterUrl: regionMovePoster,
  },
  {
    id: '2026-10-layer-thumbnail',
    date: '2026年10月',
    sortKey: '2026-10',
    title: 'レイヤーにサムネイルがつきました',
    body: 'レイヤーの一覧に、そのレイヤーの絵が小さく表示されるようになりました。サムネイルを長押しすると、絵がどのレイヤーにあるか分かりやすく表示できます。サムネイルは「表示」の設定の「レイヤーのサムネイル」で OFF にもできます。',
    videoUrl: layerThumbnailVideo,
    posterUrl: layerThumbnailPoster,
  },
];
